import React from "react";
import { Container, Grid, Typography, TextField, Button } from "@mui/material";
import { signin, socialLogin } from "../service/ApiService";
import { Link } from "react-router-dom";
import { NavigationBarLogin } from "../navigation/NavigationBarLogin";

import secureLocalStorage from "react-secure-storage";

export const Login = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const username = data.get("username");
    const password = data.get("password");
    // ApiService의 signin 메서드를 사용 해 로그인.
    signin({ username: username, password: password });
  };

  const handleSocialLogin = (provider) => {
    socialLogin(provider);
  };

  let navigationBar = NavigationBarLogin("로그인 페이지");
  let container = (
    <Container component="main" maxWidth="xs" style={{ marginTop: "8%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component="h1" variant="h5">
            로그인
          </Typography>
        </Grid>
      </Grid>
      <form noValidate onSubmit={handleSubmit}>
        {" "}
        {/* submit 버튼을 누르면 handleSubmit이 실행됨. */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="username"
              label="아이디"
              name="username"
              autoComplete="username"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              name="password"
              label="패스워드"
              type="password"
              id="password"
              autoComplete="current-password"
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" fullWidth variant="contained" color="primary">
              로그인
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              onClick={() => handleSocialLogin("github")}
              fullWidth
              variant="contained"
              style={{ backgroundColor: "#000" }}
            >
              깃허브로 로그인하기
            </Button>
          </Grid>
          <Grid item>
            <Link to="/signup" variant="body2">
              계정이 없다면 여기서 가입 해주세요.
            </Link>
          </Grid>
        </Grid>
      </form>
    </Container>
  );

  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      {container}
      {/* <Container maxWidth="md">{container}</Container>*/}
    </div>
  );
  let content = framePage;
  return <div className="App">{content}</div>;
};

export default Login;
